/* unplugin-vue-components disabled */import script from "./goods-item.vue?vue&type=script&setup=true&lang=js"
export * from "./goods-item.vue?vue&type=script&setup=true&lang=js"

import "./goods-item.vue?vue&type=style&index=0&id=091d53c5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-091d53c5"]])

export default __exports__